import API from 'api';
import { DIAMONDS_ACTION_TYPES } from '../actionTypes';

export function getDiamondAction(id) {
  return (dispatch) => {
    dispatch({ type: DIAMONDS_ACTION_TYPES.GET_DIAMOND.REQUEST, payload: id });

    return API.getDiamond(id).then(
      (response) => {
        dispatch({
          type: DIAMONDS_ACTION_TYPES.GET_DIAMOND.COMPLETE,
          payload: response.content,
        });

        return response.content;
      },
      (error) => {
        dispatch({
          type: DIAMONDS_ACTION_TYPES.GET_DIAMOND.FAILURE,
          payload: error,
        });

        throw error;
      },
    );
  };
}
